if (!customElements.get('az-good-to-know')) {
  customElements.define('az-good-to-know', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.animations = new Map();
      this.targets = new Map();
      this.items = [...this.querySelectorAll('.az-knowledge__topic')];
      const signal = this.abort.signal;
      const mobile = matchMedia('(max-width:749px)').matches;
      if (!this.initialized) {
        this.initialized = true;
        if (this.items[0] && this.dataset[mobile ? 'firstMobile' : 'first'] === 'true') this.items[0].open = true;
      }
      this.addEventListener('click', event => {
        const summary = event.target.closest('summary');
        if (!summary || !this.contains(summary)) return;
        event.preventDefault();
        const item = summary.parentElement;
        const open = !(this.targets.get(item) ?? item.open);
        this.setOpen(item, open);
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('.az-knowledge__topic');
        if (item && this.contains(item)) this.setOpen(item, true, false);
      }, { signal });
    }
    setOpen(item, open, animate = true) {
      if (open && this.dataset.single === 'true') {
        this.items.forEach(other => { if (other !== item && (other.open || this.targets.get(other))) this.setOpen(other, false, animate); });
      }
      const start = item.getBoundingClientRect().height;
      this.animations.get(item)?.cancel();
      this.animations.delete(item);
      this.targets.set(item, open);
      item.style.height = '';
      item.style.overflow = '';
      if (!animate || this.dataset.motion === 'false' || matchMedia('(prefers-reduced-motion:reduce)').matches || !item.animate) {
        item.open = open;
        this.targets.delete(item);
        return;
      }
      item.open = true;
      const end = open ? item.getBoundingClientRect().height : item.querySelector('summary').getBoundingClientRect().height + (parseFloat(getComputedStyle(item).borderTopWidth) || 0) + (parseFloat(getComputedStyle(item).borderBottomWidth) || 0);
      item.style.overflow = 'hidden';
      const animation = item.animate({ height:[`${start}px`,`${end}px`] }, { duration:Number(this.dataset.duration) || 240, easing:'cubic-bezier(.2,.65,.3,1)' });
      this.animations.set(item, animation);
      animation.onfinish = () => {
        item.open = open;
        item.style.overflow = '';
        this.animations.delete(item);
        this.targets.delete(item);
      };
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.animations?.forEach((animation, item) => {
        animation.cancel();
        item.open = this.targets.get(item) ?? item.open;
        item.style.height = '';
        item.style.overflow = '';
      });
      this.animations?.clear();
      this.targets?.clear();
    }
  });
}
